<template>
    <div class="" ref="targetElement">
<!--        <div v-if="is_client_seller" class="info-banner seller-banner d-flex justify-content-center gap-2">-->
<!--            <img src="/img/icons/forbidden.svg" alt="img-forbidden">-->
<!--            <p class="text-bat fs-7 text-left text-md-start">-->
<!--                Conecta2 Contigo es una herramienta de trabajo. Material de comunicación de uso interno y dirigido a la fuerza de ventas de BAT.-->
<!--            </p>-->
<!--        </div>-->
<!--        <div v-else class="info-banner d-flex justify-content-center gap-2">-->
<!--            <img src="/img/icons/forbidden.svg" alt="img-forbidden">-->
<!--            <p class="text-bat fs-7 text-left text-md-start">-->
<!--                Material dirigido al canal de comercialización. Prohibida su reproducción total o parcial.-->
<!--            </p>-->
<!--        </div>-->

        <legal-disclaimer v-if="showDiv" :is_client_seller="is_client_seller" :style="{ top: headerHeight + 'px' }" />
        <div class="mt-3 mb-3 mt-lg-4">
            <slick v-if="banners.length" ref="slick" :options="slickOptionsBanner" class="slick-vue mb-2">
                <div v-for="(banner, index) in banners" :key="index" v-if="index < 8"  class="px-1 px-lg-4">
                    <a :title="banner.title" :id="'top-banner-' + (index+1)" :href="banner.link" target="_self" class="d-flex justify-content-center w-100">
                        <img v-if="$mq !== 'sm' && banner.image && banner.image.includes('.cloudfront.net')" :src="banner.image" :alt="banner.title" class="rounded-4 w-100">
                        <img v-else-if="$mq === 'sm' && banner.small_image && banner.small_image.includes('.cloudfront.net')" :src="banner.small_image" :alt="banner.title" class="rounded-4 w-100">
                        <img v-else :src="url_media + ($mq === 'sm' ? cleanImage(banner.small_image) : cleanImage(banner.image))" :alt="banner.title" class="rounded-4 w-100">
                    </a>
                </div>
            </slick>
        </div>
    </div>
</template>

<script>
import Slick from 'vue-slick';
import 'slick-carousel/slick/slick.css';
export default {
    components: { Slick },
    props: {
        url_media: {
            default: '',
        },
        is_client_seller: {
            default: false
        }
    },
    data() {
        return {
            loading: 0,
            banners: [],
            slickOptionsBanner: {
                dots: false,
                arrows: false,
                infinite: true,
                centerMode: true,
                autoplay: true,
                autoplaySpeed: 5000,
                slidesToShow: 1,
                slidesToScroll: 1,
                responsive: [
                    {
                        breakpoint: 1600,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        }
                    },
                    {
                        breakpoint: 1150,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        }
                    }
                ]
            },
            headerHeight: 0,
            showDiv: true,
        }
    },
    mounted () {
        window.addEventListener('scroll', this.handleScroll);
        this.loadBanners();
        const header = document.getElementById('header-bat');
        if (header) {
            this.headerHeight = header.offsetHeight;
        }
        window.addEventListener('resize', this.updateHeaderHeight);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.updateHeaderHeight);
        window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
        loadBanners(){
            this.loading++
            axios.get(`load-banner-data`)
            .then(({data}) => {
                this.banners = data.banners
                this.loading--
            })
        },
        cleanImage(image){
            if(image){
                return JSON.parse(image)[0]
            }else{
                return ""
            }
        },
        updateHeaderHeight() {
            const header = document.getElementById('header-bat');
            if (header) {
                this.headerHeight = header.offsetHeight;
            }
        },
        handleScroll() {
            const offset = 100;
            const targetElementPosition = this.$refs.targetElement.offsetTop - offset;
            const scrollPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
            this.showDiv = scrollPosition >= targetElementPosition;
        },
    }
}
</script>
